import { SpherePlatformAppPaths } from '@sphere/platform';

export const PATHS: SpherePlatformAppPaths = {
    ['DASHBOARD_PATH']: 'dashboard',
    ['DATA_DELIVERIES_PATH']: 'data-deliveries',
    ['CORRECTIONS_PATH']: 'corrections',
    ['SYNTACTIC_CHECKS_PATH']: 'syntactic-checks',
    ['DELIVERY_TIMES_PATH']: 'delivery-times',
    ['SUBSCRIPTIONS_PATH']: 'subscriptions',
    ['DATA_COVERAGE_PATH']: 'data-coverage'
};
